<template>
    <div class="dvgraficoline">
        <v-chart :options="options"/>
    </div>
</template>
<style>

</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'


const labelOption = {
  show: false,

  formatter: '{c}  {name|{a}}',
  fontSize: 16,
  rich: {
    name: {}
  }
};


export default {
    name : "cmpgraficobaragrupado",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'titulo',
        'agrupamento',
		'series'
    ],
    data () {
        return {
            options : {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        mark: { show: true },
                        dataView: { 
                            show: true, 
                            readOnly: true,
                            title: 'Ver Dados',
                            lang: ['Ver Dados', 'Fechar', 'Atualizar']
                        },
                        magicType: { 
                            show: true, 
                            type: ['line', 'bar', 'stack'],
                            title: {
                                line: 'Gráfico de Linhas',
                                bar: 'Gráfico de Barras',
                                stack: 'Empilhar'
                            }
                        },
                        restore: { show: true, title: 'Restaurar' },
                        saveAsImage: { show: true, title: 'Salvar como Imagem' }
                    }
                },
                // xAxis: {
                //     data: [],
                //     show: true 
                // },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: { show: false },
                        data: []
                    }
                ],
                yAxis: {
                    type: 'value',
                  
                },
                // series: 
                //     {
                //         data: [],
                //         type: 'bar',
                //         showBackground: false,
                //         color: "#007bff"         
                //     }
                series: [
                         
                ]
            }
        }
    },
    mounted: function () {         
    },    
    computed:{
    },
    watch:{
        series(){
            this.options.title.text     			= this.titulo;
            this.options.xAxis[0].data 			    = this.agrupamento;
			   this.options.series                  = this.series;			
        }
    }    
}
</script>